/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SheepSlotBarComponent.vue?vue&type=template&id=2f0168e1&scoped=true"
import script from "./SheepSlotBarComponent.vue?vue&type=script&lang=js"
export * from "./SheepSlotBarComponent.vue?vue&type=script&lang=js"
import style0 from "./SheepSlotBarComponent.vue?vue&type=style&index=0&id=2f0168e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0168e1",
  null
  
)

export default component.exports